// Module
var code = "<label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\"> {{(to.showLabel === undefined || to.showLabel) ? to.label : '&nbsp;'}} {{(to.required && (to.showLabel === undefined || to.showLabel)) ? '*' : ''}} </label> <formly-transclude></formly-transclude> ";
// Exports
var _module_exports = code;;
var path = 'ui-formly/wrappers/label/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;